import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { STORY_TYPE_METADATA_FIELDS, storyTypeLabel } from "%/dynamic-components/render-engine/constants/story-type-metadata-fields";

export default class StoryTypeSelector extends BaseOption {
  static label = "Story type";
  static userInterfaceComponent = () => {
    const options = Object.keys(STORY_TYPE_METADATA_FIELDS)
        .map(key => ({ id: key, name: storyTypeLabel(key) }));

    return {
      component: inspectorTools.SIMPLE_PICKER,
      props: { options },
    };
  };

  static defaultValue = "";
}
